'use strict';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {TaskType} from '../../tasks/enums/TaskType';
import {projectTasksStates} from '../../tasks/router-config';
import {getProjectRequirementList} from '../reducers/state';
import {buildReqList} from './config/reqListConfig';
import {PROJECT_LIST_PREFIX} from './state';


const parentPath = 'project-tasks';
const resourcePath = `file-requirements`;
const childPath = 'requirements';

export const {
  /** @type {ReduxList} */
  reduxList,
  componentOptions,
} = buildReqList({
  prefix: PROJECT_LIST_PREFIX,
  getState: getProjectRequirementList,
  listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
  listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
  deleteItemPath: (itemId, payload) => `${payload.collection}/${itemId}`,
}, {
  taskType: TaskType.PROJECT,
  viewName: projectTasksStates.requirements,
});



// WEBPACK FOOTER //
// ./src/js/requirements/redux/projectReqList.js